/**
 * Cœur des favoris sur les cartes produit.
 *
 * L'état vit dans le localStorage du visiteur : le thème n'a pas de compte
 * client relié à une liste d'envies, et une liste qui s'effacerait au
 * rechargement ne vaudrait rien. Chaque produit est repéré par son URL.
 *
 * Délégation sur le document : l'éditeur de thème remplace le HTML des
 * sections, ce qui décrocherait des écouteurs posés sur les boutons.
 */
const CLE = 'kb-favoris';

function lire() {
  try {
    const brut = JSON.parse(localStorage.getItem(CLE));
    return new Set(Array.isArray(brut) ? brut : []);
  } catch {
    // Navigation privée, stockage bloqué, données corrompues : on repart
    // d'une liste vide plutôt que de casser la page.
    return new Set();
  }
}

function ecrire(favoris) {
  try {
    localStorage.setItem(CLE, JSON.stringify([...favoris]));
  } catch {
    /* rien à faire : le cœur reste juste à l'écran, sans être retenu */
  }
}

function peindre(bouton, actif) {
  const nom = bouton.getAttribute('aria-label')?.replace(/^[^:]*:\s*/, '') ?? 'ce produit';
  bouton.classList.toggle('on', actif);
  bouton.setAttribute('aria-pressed', String(actif));
  bouton.setAttribute('aria-label', `${actif ? 'Retirer des favoris' : 'Ajouter aux favoris'} : ${nom}`);
}

/**
 * Les pastilles du header et du tiroir de menu affichent le nombre de
 * favoris. À zéro elles disparaissent : un « 0 » en permanence attirerait
 * l'œil sur une absence.
 */
function compter(favoris) {
  const n = favoris.size;
  document.querySelectorAll('[data-favoris-count]').forEach((pastille) => {
    pastille.textContent = n;
    pastille.hidden = n === 0;
  });
}

function restaurer() {
  const favoris = lire();
  document.querySelectorAll('.cat-fav[data-favori]').forEach((bouton) => {
    peindre(bouton, favoris.has(bouton.dataset.favori));
  });
  compter(favoris);
}

document.addEventListener('click', (event) => {
  const bouton = event.target.closest('.cat-fav[data-favori]');
  if (!bouton) return;

  const favoris = lire();
  const cle = bouton.dataset.favori;
  const actif = !favoris.has(cle);
  if (actif) favoris.add(cle);
  else favoris.delete(cle);
  ecrire(favoris);
  peindre(bouton, actif);
  compter(favoris);
});

document.addEventListener('shopify:section:load', restaurer);
restaurer();
